import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", null, "You don't seem to have ordered anything yet. Go to your favorite restorant and order something", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_table = _resolveComponent("b-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_table, {
      striped: "",
      hover: "",
      fields: _ctx.tableFields,
      items: _ctx.orders,
      "show-empty": ""
    }, {
      "cell(amount)": _withCtx((data) => [
        _createTextVNode(" $ " + _toDisplayString(data.item.amount), 1)
      ]),
      "cell(orderCode)": _withCtx((data) => [
        _createVNode(_component_router_link, {
          to: {name:'orderdetailsbycode',params:{orderCode:data.item.orderCode}}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(data.item.orderCode), 1)
          ]),
          _: 2
        }, 1032, ["to"])
      ]),
      "cell(id)": _withCtx((data) => [
        _createVNode(_component_router_link, {
          to: {name:'orderdetails',params:{id:data.item.id}}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(data.item.id), 1)
          ]),
          _: 2
        }, 1032, ["to"])
      ]),
      empty: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["fields", "items"])
  ]))
}